exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@keyframes fadeIn {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n.story .story-meta h1 {\n  font-size: 1.5rem; }\n  .story .story-meta h1 .author {\n    font-size: 0.8rem; }\n\n.story .node {\n  margin: 35px auto; }\n  .story .node .node-links {\n    display: flex; }\n    .story .node .node-links button.node-link {\n      border-color: #30bced;\n      margin-bottom: 20px;\n      color: #30bced;\n      display: block;\n      width: 100%; }\n      .story .node .node-links button.node-link:hover {\n        background-color: #30bced;\n        color: white; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/Story/Story.scss
// module id = 149
// module chunks = 0